import {
    doc,
    deleteDoc,
    updateDoc,
    arrayRemove
} from "firebase/firestore"
import { db } from "../../firebase"
import { useListingsContext } from "../../context/ListingsContext"
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { LoginModalContext } from "../../context/LoginModalContext";

const ListingCard = ({listing, listings, setListings}) => {
    // const listings = useListingsContext().listings
    // const updateListings = useListingsContext().updateListings
    const thumbnailImage = listing.image_urls.length? listing.image_urls[0] : ""
    const { currentUser } = useContext(AuthContext)
    const { setLoginModalOpen } = useContext(LoginModalContext)

    const onDeleteClick = async (event, listing_id) => {
        event.preventDefault()
        const res = window.confirm("Are you sure you want to delete this listing?")
        if (res) {
            try {
                await deleteDoc(doc(db,`listings/${listing_id}/private`, "data"))
                await deleteDoc(doc(db, "listings", listing_id))
                // const response = await fetch(`http://localhost:5000/listings/${listing_id}`, {
                //     method: "DELETE",
                // })
                
                // console.log(response)
                // setListings(listings.filter(listing => listing.listing_id !== listing_id))
                await updateDoc(doc(db, "users", currentUser.uid), {activeListings: arrayRemove(listing_id)})
                const newListings = listings.filter((listing) => listing.listing_id !== listing_id)
                console.log(newListings)
                setListings(newListings)
                // setListings(newListings)
            } catch (err) {
                console.error(err.message)
            }
        }
    }

    // const navigate = useNavigate()

    // const handleClick = (e) => {
    //     if (!currentUser) {
    //         e.preventDefault()
    //         setLoginModalOpen(true)
    //     }

    //     // navigate(`/item/${listing.listing_id}`, {state:{listing_id: listing.listing_id}}) :
    //     // localStorage.setItem("listingId", listing.listing_id)
    // }

    return (
        <NavLink className="listing-card"  
            to={{
                pathname: `/item/${listing.id}`,
            }}
            // state= {{listing_id: listing.listing_id}}
            // onClick={handleClick}
         >
            <div className="listing-card-img-div">
                <img src={thumbnailImage} className="thumbnail-image"></img>
            </div>
            <div className="listing-card-info">
                <div className="listing-card-text" style={{"fontWeight": "500"}}>
                    {listing.price && (listing.price > 0) ? `$${listing.price}` : "FREE"}
                </div>
                <div className="listing-card-text listing-title" style={{"fontWeight": "450"}}>
                    {listing.title}
                </div>
                <div className="listing-card-text listing-location" style={{"fontSize": ".8rem"}}>
                    {/* {listing.addressData.addressComponents[2].long_name} */}
                    {listing.location}
                </div>
                {
                    useLocation().pathname === "/mylistings" ? 
                    <button className="btn btn-danger listing-card-delete" onClick={(e) => onDeleteClick(e, listing.listing_id)}>Delete</button> :
                    <></>
                }
            </div>
        </NavLink>
    )
}

export default ListingCard